import { routeTitleContracts } from "@/lib/route-title-metadata";

const publicHomepageUrl = "https://veronics.org";
const publicHomepageSocialProfiles = [
  "https://www.facebook.com/profile.php?id=61577022772656",
  "https://www.instagram.com/hello.veronics/",
];

export const publicHomepageStructuredData = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Veronics",
  url: publicHomepageUrl,
  description: routeTitleContracts["/"].description,
  sameAs: publicHomepageSocialProfiles,
  email: "support@veronics.org",
};

export const publicHomepageStructuredDataJson = JSON.stringify(publicHomepageStructuredData);
